<template>
    <div class="space-y-6">
        <FormRadioGroup
            label="Select the type of trip"
            name="trip_type"
            v-model="form.trip_type"
            :options="tripTypeOptions"
            :errors="errors"
            required
        />

        <UiInput
            type="number"
            id="travelers_count"
            name="travelers_count"
            label="How many people will travel?"
            v-model:inputValue="form.travelers_count"
            :errors="errors"
            :options="{ required: true }"
        />

        <UiInput
            id="home_airport"
            name="home_airport"
            label="Home airport"
            placeholder="e.g. JFK"
            v-model:inputValue="form.home_airport"
            :errors="errors"
            :options="{ required: true }"
        />

        <FormYesNo
            label="Are you willing to position to another airport if it means better availability?"
            name="willing_to_position"
            v-model="form.willing_to_position"
            :errors="errors"
            required
        />

        <UiInput
            v-if="!isMultiCity"
            id="arrival_airport"
            name="arrival_airport"
            label="Arrival airport"
            placeholder="e.g. NRT"
            v-model:inputValue="form.arrival_airport"
            :errors="errors"
            :options="{ required: true }"
        />

        <UiTextarea
            v-if="isMultiCity"
            id="multi_city_stops"
            name="multi_city_stops"
            :label="
                isExtendedMultiCity
                    ? 'List the destinations you want to stop at for your multi-city trip (more than 3 stops)'
                    : 'List the destinations you want to stop at for your multi-city trip (maximum of 3 stops)'
            "
            placeholder="One destination per line"
            v-model:inputValue="form.multi_city_stops"
            :errors="errors"
            :options="{ required: true }"
        />

        <UiInput
            v-if="isExtendedMultiCity"
            type="number"
            id="multi_city_stop_count"
            name="multi_city_stop_count"
            label="Please enter the total number of stops listed above"
            v-model:inputValue="form.multi_city_stop_count"
            :errors="errors"
            :options="{ required: true }"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import UiTextarea from '@/components/ui/inputs/ui-textarea.vue';
import FormRadioGroup from '@/components/award-bookings/request-form/form-radio-group.vue';
import FormYesNo from '@/components/award-bookings/request-form/form-yes-no.vue';

const props = defineProps({
    form: { type: Object, required: true },
    errors: { type: Object, default: null },
    tripTypeOptions: { type: Array, required: true },
});

const isMultiCity = computed(() =>
    ['multi_city', 'multi_city_extended'].includes(props.form.trip_type)
);
const isExtendedMultiCity = computed(
    () => props.form.trip_type === 'multi_city_extended'
);
</script>
